import { z } from 'zod';
/**
 * Whole-feature switches the console turns on and off. With no admin choice a
 * switch follows its server setting (GYM_API_ENABLED, RECAP_ENABLED,
 * RHYTHM_ENABLED, AI_RATINGS_ENABLED, ACTIVITIES_ENABLED).
 */
export const FEATURE_SWITCH_KEYS = [
    'gym_api',
    'monthly_recap',
    'rhythm',
    'ai_ratings',
    'activities',
];
export const featureSwitchKeySchema = z.enum(FEATURE_SWITCH_KEYS);
export const adminFeatureSwitchSchema = z.object({
    key: featureSwitchKeySchema,
    /** What it does, for the console: "Steado for Gyms", "Monthly Recap". */
    label: z.string(),
    description: z.string(),
    enabled: z.boolean(),
    /** `admin`: set in the console; `default`: follows the server setting. */
    source: z.enum(['admin', 'default']),
    /** The server setting, what `default` means. */
    defaultEnabled: z.boolean(),
    updatedAt: z.string().nullable(),
});
export const featureSwitchParamsSchema = z.object({ key: featureSwitchKeySchema });
export const setFeatureSwitchBodySchema = z.object({
    enabled: z.boolean(),
    /** The switch's key, typed by the admin: a switch is never flipped by a stray click. */
    confirmation: z.string(),
});
//# sourceMappingURL=feature-switches.js.map